<p class="nova-body-14">
  @for (part of messageParts(); track $index) {
    @if (part.type === "text") {
      <span>{{ part.content }}</span>
    } @else if (part.type === "link") {
      <a
        class="nova-link"
        tabindex="0"
        appTrackedLink
        [attr.data-testid]="part.linkType"
        [trackId]="`legal-acknowledgements:${part.linkType}`"
        (click)="onLinkClicked(part.linkType)"
        (keydown.enter)="onLinkClicked(part.linkType)"
        >{{ part.content }}</a
      >
    }
  }
</p>
<app-legal-acknowledgement-dialog />
